<mat-form-field class="default-field-width" [formGroup]="form" appearance="fill">
  <mat-label>{{ 'SELECT.PLACEHOLDER' | translate }}</mat-label>
  <mat-select [formControlName]="controlName">
    <mat-option [value]="KeyIndicatorType.SALES_SQFT">
      {{ 'SELECT.AVG' | translate }} {{ 'SELECT.SALES_SQFT' | translate }}
    </mat-option>
    <mat-option [value]="KeyIndicatorType.SALES_VOLUME">
      {{ 'SELECT.AVG' | translate }} {{ 'SELECT.SALES_VOLUME' | translate }}
    </mat-option>
    <mat-option [value]="KeyIndicatorType.STORE_COUNT">
      {{ 'SELECT.STORE_COUNT' | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
